import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';

import { WizardStepComponent } from './wizard-step/wizard-step.component';
import { WizardComponent } from './wizard.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		AnalyticsModule,
		CwpNgFrameworkModule,
		DzButtonModule
	],
	declarations: [WizardComponent, WizardStepComponent],
	exports: [WizardComponent, WizardStepComponent]
})
export class WizardModule { }
